// ###########################################################################
// HEADER - Add class .min to scroll down
$(document).ready(function() {
  $(window).scroll(function() {
    var scrollPosition = $(window).scrollTop();
    if (scrollPosition > 300) {
      $('.main-header').addClass('min');
    } else {
      $('.main-header').removeClass('min');
    }
  });
});

// ###########################################################################
// ANIMATION FADE TO TOP - element dom
var $animation_elements = $('.animated');
var $window = $(window);

function check_if_in_view() {
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);

    $.each($animation_elements, function() {
        var $element = $(this);
        var element_height = $element.outerHeight();
        var element_top_position = $element.offset().top;
        var element_bottom_position = (element_top_position + element_height);

        if ((element_bottom_position >= window_top_position) &&
            (element_top_position <= window_bottom_position)) {
            $element.addClass('active');
        }
    });
}

$window.on('scroll resize', check_if_in_view);
$window.trigger('scroll');

(function($) {

  function initAnimations() {
    var $elements = $('.animated:not(.is-observed)');
    
    if ($elements.length === 0) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          $(el).addClass('active');
          $(el).removeClass('animated');
          observer.unobserve(el);
        }
      });
    }, {
      threshold: 0.2
    });

    $elements.each(function() {
      var el = this;
      $(el).addClass('is-observed');
      observer.observe(el);
    });
  }

  $(document).ready(function() {
    initAnimations();
    setTimeout(function() {
      initAnimations();
    }, 500);
  });

  if (document.body) {
    var mutationObserver = new MutationObserver(function() {
      initAnimations();
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

})(jQuery);

// ###########################################################################
// PRIMARY NAVIGATION
$("#btnMobile").click(function (e) {
  $(this).toggleClass("cross");
  $(".main-nav-wrapper").toggleClass("open");
  $("body").toggleClass("overflow");
});

// ###########################################################################
// SUBNAV NAVIGATION
$("ul > li.menu-item-has-children > a").click(function (e) {
    e.preventDefault();
    var LiParent =$(this).parent().attr('class');
    if(! LiParent.includes("openSub-menu") ){
        $('ul > li.menu-item-has-children > a').parent().removeClass("openSub-menu");
    }
    $(this).parent().toggleClass("openSub-menu");
});

// CLOSE NAV WHEN CLICK ANYWHERE
$(document).on("click", function (event) {
    var $trigger = $(".menu-item-has-children");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $(".menu-item-has-children").removeClass("openSub-menu");
    }
});

// ###########################################################################
// CLOSE CPT Info
$(document).on('click', '.close-cpt-info', function (e) {
  e.preventDefault();
  $("#info-cpt").removeClass("open");
});

// ###########################################################################
// ANCRE
$('a[href^="#"]').on('click',function (e) {
    e.preventDefault();
    var nav = $('nav');
    var target = this.hash,
    $target = $(target);

    $('html, body').stop().animate({
        'scrollTop': $target.offset().top - nav.height()
    }, 1200, 'swing', function () {
        window.location.hash = target;
    });
});

// ###########################################################################
// SLICK - slideshow & slider
if (typeof $.fn.slick !== 'undefined') {
  $(document).ready(function(){
    $('.slideshow .slider-wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      infinite: true,
      cssEase: 'ease',
      fade: true,
      speed: 1000,
    });

    $('.slick-main').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      asNavFor: '.slick-nav',
      adaptiveHeight: true
    });

    $('.slick-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.slick-main',
      focusOnSelect: true,
      arrows: false,
      centerMode: false
    });
  });
}